import {
  Component,
  OnChanges,
  SimpleChanges,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core'

import { FormControl, Validators } from '@angular/forms'

import { ToastMessage } from '../../toast-message/toast-message.service'
import { LogService } from '../../log-service.service'
import { HelperService } from '../../helper.service'

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner'
import { BasicInfoService } from './basic-info.service'
import { ActivatedRoute, Router } from '@angular/router'

import { MatDialog, MatDialogRef } from '@angular/material'
import { Hotkey, HotkeysService } from 'angular2-hotkeys'
import './basic-info.component.css'
import { RemarkPopUpComponent } from '../../remarks-popup/remark-pop-up.component'
import { PopUpMessageComponent } from '../../pop-up-message/pop-up-message.component'

const _ = require('lodash')

@Component({
  selector: 'basic-info',
  template: require('./basic-info.component.html'),
  providers: [ToastMessage, BasicInfoService, LogService],
})
export class BasicInfoComponent implements OnChanges, OnInit {
  emailFormControl = new FormControl('', [Validators.email])
  mobileFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern('[0-9]{10}'),
  ])
  firstNameFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern('[a-zA-Z](?!.*  )[a-zA-Z ]{0,199}'),
  ])
  lastNameFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern('[a-zA-Z](?!.*  )[a-zA-Z ]{0,199}'),
  ])
  birthDateFormControl = new FormControl(new Date())
  lastDispositionFormControl = new FormControl('', [
    Validators.required
  ])
  captainInstalledAppsFormControl = new FormControl('', [
    Validators.required
  ])

  @Input() data: any
  @Output() birthDate: EventEmitter<any> = new EventEmitter()
  @Output() firstNameInput: EventEmitter<any> = new EventEmitter()
  @Output() userPreferences: EventEmitter<any> = new EventEmitter()
  @Output() modeChange: EventEmitter<any> = new EventEmitter()
  @Output() typeServiceMapping: EventEmitter<any> = new EventEmitter()
  @Output() typeChange: EventEmitter<any> = new EventEmitter()
  public basicData: any
  public riderLogData: any
  public response: any
  public isActive = false
  public screenBreakpoint = false
  public fileSelected: any
  public error: any
  public userInitialData: any = {}
  public gender = { 0: 'Male', 1: 'Female', 2: 'Other' }
  public isModalOpen = false
  public userMapping = {}
  public modes = []
  public modeName: string
  public selectedMode: any
  public isAssureServiceEnabled = false
  public assureFees;
  public mobileChangeRequest: any
  public lastDisposition: any

  public captainInstalledApps = []
  public fleetTypes = []
  public fleetManagers = []
  public fleetType: string
  public fleetManager: string
  public newMode: string
  public fleetId = ''
  public showAttachFleet = false
  public showDetachFleet = false
  public showChangeRequest = false

  public showLastDisposition = false

  public showRiderType = false
  public showCaptainInstalledApps = false
  public isTypeVisible = false
  public optionalDocs = []
  public typeOptions = []
  public typeServiceMap = {}
  public rejectedChangeRequest = false
  public approvedChangeRequest = false
  public noDlOrRcRider = "";
  public suspendedServiceGroups: any[] = [];
  public foodDelivery = 'Food Delivery'
  public isB2BEligible = ''
  public notEligibleReasons;
  public b2bEligibleApiErrorMessage;
  public b2bEligibileFlagToggle = true
  public isEligibilityApiCalled = false
  public isRefreshing = false
  public isrestrictDLEditEnabled = false
  private isWhatsappR2AEnabled: boolean = false
  private isAllowedToSendR2AWhatsappMessage: boolean = true
  private whatsappAckowledgementPositiveFeedback: string = ''
  private whatsappAckowledgementNegativeFeedback: string = ''
  public optimisedProfilePictureImageUrl = ''
  public maxDate = new Date()
  public numberChangeRejectionReasons = []

  // permission base editing
  @Input() allowEditing: any
  @Input() allowMobileEdit: any
  @Input() allowFleetEdit: any
  @Input() actorId: any

  constructor(
    private _toastMessage: ToastMessage,
    private _logService: LogService,
    private _basicInfoService: BasicInfoService,
    public dialog: MatDialog,
    private spinnerService: Ng4LoadingSpinnerService,
    private _hotkeysService: HotkeysService,
    private helperService: HelperService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  private resolveCaptainGender(data: any): number | undefined {
    if (!data) {
      return undefined;
    }
    const riderGender = data.gender;
    if (riderGender === 0 || riderGender === 1 || riderGender === 2) {
      return riderGender;
    }
    const userGender = data.userId && data.userId.gender;
    if (userGender === 0 || userGender === 1 || userGender === 2) {
      return userGender;
    }
    return undefined;
  }

  private setCaptainGender(data: any, genderValue: number) {
    data.gender = genderValue;
    if (data.userId && typeof data.userId === 'object') {
      data.userId.gender = genderValue;
    }
  }

  get captainGender(): number | undefined {
    return this.resolveCaptainGender(this.basicData);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.data && changes.data.currentValue) {
        this.basicData = changes.data.currentValue;
        this.basicData.servicesInterested = this.basicData.servicesInterested ? this.basicData.servicesInterested.toString() : '';
        const resolvedGender = this.resolveCaptainGender(this.basicData);
        if (resolvedGender !== undefined) {
          this.setCaptainGender(this.basicData, resolvedGender);
        }
        this.userInitialData = _.cloneDeep(this.basicData); // to compare with old values for log service
        this.modes = this.basicData.modes;
        this.isActive = this.basicData.active;
        const registrationDate = new Date(this.basicData.registeredDate).getTime() > 0 ? new Date(
          this.basicData.registeredDate
        ) : new Date();
        this.getBirthDateMaxRange(registrationDate)
      }
      if (
        this.basicData &&
        this.basicData.userId &&
        this.data &&
        this.data.city
      ) {
        var userId = this.basicData._id
        this.getUserPreferencesInformation(userId, this.data.city)
      }
      if (
        this.basicData &&
        this.basicData.userId &&
        this.data &&
        this.data.city
      ) {
        var userId = this.basicData._id
        this.getUserPreferencesInformation(userId, this.data.city)
      }
      if (this.basicData && this.basicData.type && (this.basicData.type === "noDl" || this.basicData.type === "noRc" || this.basicData.type === "Erickshaw")) {
        if (this.basicData.type === "noDl") {
          this.noDlOrRcRider = "B2B"
        }
        else if (this.basicData.type === "Erickshaw") {
          this.noDlOrRcRider = "E-Rickshaw"
        }
        else {
          this.noDlOrRcRider = "Rental Bike/Auto"
        }
        this.showRiderType = true
      }

      // Fetch type config when data changes
      this.fetchTypeConfig();

      // Normalize type value for UI display after config is loaded
      this.normalizeTypeValue();

      if (this.basicData && this.basicData.profilePicture) {
        if (
          this.basicData.profilePicture.qos &&
          Array.isArray(this.basicData.profilePicture.qos) &&
          this.basicData.profilePicture.qos.includes('1')
        ) {
          const imageUrl = new URL(this.basicData.profilePicture.link)
          imageUrl.searchParams.set('qos', '1')
          this.optimisedProfilePictureImageUrl = imageUrl.toString()
        } else {
          this.optimisedProfilePictureImageUrl =
            this.basicData.profilePicture.link
        }
      }
      if (this.basicData && this.basicData.statusUpdates) {
        this.isWhatsappR2AEnabled =
          this.basicData.statusUpdates.isWhatsappR2AEnabled
        this.getUserPreferencesInformation(userId, this.data.city)
      }
      if (this.basicData && this.basicData.toggles) {
        this.isrestrictDLEditEnabled = this.basicData.toggles.restrictEditDlEnabled;
      }

      if (this.basicData && this.basicData.typeList) {
        let fleetTypes = this.basicData.typeList.fleetTypeList.slice(1, -1).split(',');
        this.fleetTypes = fleetTypes.map(type => type.trim());
      }


      if (this.basicData && this.basicData.profilePicture) {
        if (this.basicData.profilePicture.qos &&
          Array.isArray(this.basicData.profilePicture.qos) &&
          this.basicData.profilePicture.qos.includes("1")) {
          const imageUrl = new URL(this.basicData.profilePicture.link)
          imageUrl.searchParams.set("qos", "1")
          this.optimisedProfilePictureImageUrl = imageUrl.toString()
        } else {
          this.optimisedProfilePictureImageUrl = this.basicData.profilePicture.link
        }
      }
      if (this.basicData && this.basicData.statusUpdates) {
        this.isWhatsappR2AEnabled = this.basicData.statusUpdates.isWhatsappR2AEnabled;
        this.getUserPreferencesInformation(userId, this.data.city);
      }

      if (changes.allowEditing && changes.allowEditing.currentValue === false) {
        this.firstNameFormControl.disable()
        this.mobileFormControl.disable()
        this.lastNameFormControl.disable()
        this.birthDateFormControl.disable()
      }
      this.modeName = this.basicData && this.basicData.modeId && this.basicData.modeId.mode || ''
      if (this.basicData && this.basicData.mobile) {
        var mobile = this.basicData.mobile;
        this.fetchAgentLastDisposition(mobile);
        this.fetchCaptainInstalledApps(mobile);
      }
      if (this.shouldRestrcictBirthDateEditToVerifiedDocs() && this.basicData.birthDate) {
        this.birthDateFormControl.disable()
      }
      if (this.basicData && this.basicData.fleetId) {
        this.fetchAttachedFleetManagerAndType();
      }
      this.route.queryParams.subscribe(params => {
        if (params['isCRPresent'] === 'true') {
          this.viewPhoneNumberChangeRequest({ checked: true });
        }
      })
    }
  }

  ngOnInit() {
    // Hide zoom lens on component init
    const blowupLens = document.getElementById('BlowupLens');
    if (blowupLens) {
      blowupLens.style.display = 'none';
    }
    
    // Set screen breakpoint using vanilla JS
    this.screenBreakpoint = window.innerWidth <= 1040;
  }

  onResize(event) {
    this.screenBreakpoint = event.target.innerWidth <= 1040;
  }

  getBirthDateMaxRange(registrationdate: Date) {
    let regDate = new Date(registrationdate);
    let maxDate = new Date();
    maxDate.setFullYear(regDate.getFullYear() - 18);
    this.maxDate = maxDate;
  }

  fetchAttachedFleetManagerAndType() {
    this._basicInfoService.getFleetManagers('', this.basicData.fleetId, localStorage.getItem('userId')).subscribe((res: any) => {
      if (res && res.data) {
        this.fleetType = res.data[0].type;
        this.fleetManager = `${res.data[0].name} - ${res.data[0].mobile}`;
        this.fleetTypes = [];
        this.showDetachFleet = true;
      }
    }, error => {
      this.showDetachFleet = false;
      const errorMessage = error.error && error.error.message ? error.error.message : 'Could not fetch fleet managers';
      this._toastMessage.openSnackBarError(errorMessage);
    });
  }

  fetchFleetManagersForType() {
    if (this.basicData && !this.basicData.fleetId && this.fleetType) {
      this._basicInfoService.getFleetManagers(this.fleetType, '', localStorage.getItem('userId')).subscribe((res: any) => {
        if (res && res.data) {
          this.fleetManagers = res.data.map((manager: any) => ({ name: manager.name, _id: manager._id, mobile: manager.mobile }));
          this.showAttachFleet = true;
        }
      }, error => {
        const errorMessage = error.error && error.error.message ? error.error.message : 'Could not fetch fleet info';
        this._toastMessage.openSnackBarError(errorMessage);
      });
    }
  }

  formatManagerName(manager: any): string {
    return `${manager.name} - ${manager.mobile}`;
  }

  onFleetManagerChange(managerName: string) {
    const selectedManager = this.fleetManagers.find(manager => `${manager.name} - ${manager.mobile}` === managerName);
    if (selectedManager) {
      this.fleetId = selectedManager._id;
    }
  }

  attachToFleet() {
    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '550px',
      data: {
        options: [],
        title: 'Are you sure you want to attach the fleet for captain?',
        notes: [
          'Account will be deactivated.',
          'Captain should be off-duty before attaching the fleet',
        ],
        reason: 'attachToFleet',
        buttonText: 'Attach',
        cancelText: 'Cancel',
        styles: {
          title: 'font-size-20 margin-bottom-30',
          actionClass: 'doc-details-change-confirm',
          note: 'margin-bottom-12 margin-top-30 color-grey'
        },
      },
    })

    dialogRef.afterClosed().subscribe((attachToFleet) => {
      if (attachToFleet) {
        this.attachFleetToCaptain()
      }
    })
  }

  attachFleetToCaptain() {
    this._basicInfoService.attachFleetToRider(this.basicData._id, this.fleetId, localStorage.getItem('userId')).subscribe((res: any) => {
      if (res.message === 'success') {
        window.location.reload();
      }
    }, error => {
      const errorMessage = error.error && error.error.message ? error.error.message : 'Could not complete attachment of fleet to captain';
      this.showAttachFleet = true;
      this._toastMessage.openSnackBarError(errorMessage);
    });
  }

  detachFromFleet() {
    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '550px',
      data: {
        options: [],
        title: 'Are you sure you want to detach the fleet for captain?',
        notes: [
          'Account will be deactivated',
          'Captain will be logged out of app',
          'Captain should be off-duty before detaching the fleet',
        ],
        reason: 'detachFromFleet',
        buttonText: 'Detach',
        cancelText: 'Cancel',
        styles: {
          title: 'font-size-20 margin-bottom-30',
          actionClass: 'doc-details-change-confirm',
          note: 'margin-bottom-12 margin-top-30 color-grey'
        },
      },
    })

    dialogRef.afterClosed().subscribe((detachFromFleet) => {
      if (detachFromFleet) {
        this.detachFleetFromCaptain()
      }
    })
  }

  detachFleetFromCaptain() {
    this._basicInfoService.detachFleetFromRider(this.basicData._id, this.basicData.fleetId, localStorage.getItem('userId'), this.basicData.modeId._id).subscribe((res: any) => {
      if (res.message === 'success') {
        window.location.reload();
      }
    }, error => {
      const errorMessage = error.error && error.error.message ? error.error.message : 'Could not complete detachment of fleet from captain';
      if (errorMessage === 'Please end the shift of captain') {
        const dialogRef = this.dialog.open(PopUpMessageComponent, {
          width: '550px',
          data: {
            options: [],
            title: 'Captain has not ended the shift',
            notes: [
              'Please make sure to end the shift of captain before detaching the fleet',
            ],
            reason: 'detachFromFleet',
            buttonText: 'Yes',
            styles: {
              title: 'font-size-20 margin-bottom-30',
              actionClass: 'doc-details-change-confirm',
              note: 'margin-bottom-12 margin-top-30 color-grey'
            },
          },
        })

        dialogRef.afterClosed().subscribe()
      }
      this.showDetachFleet = true;
      this._toastMessage.openSnackBarError(errorMessage);
    });
  }

  shouldRestrcictBirthDateEditToVerifiedDocs(): boolean {
    return this.basicData && this.basicData.license &&
      this.basicData.license.verified && this.basicData.license.status === "approved" &&
      this.isrestrictDLEditEnabled && localStorage.getItem('isUserAnAdmin') === 'false';
  }

  updateFirstName() {
    let response
    if (this.userInitialData.firstName === this.basicData.firstName) {
      this._toastMessage.openSnackBarError('Please change the value to update')
    } else {
      if (
        (this.firstNameFormControl.errors &&
          this.firstNameFormControl.errors.required) ||
        (this.firstNameFormControl.errors &&
          this.firstNameFormControl.errors.pattern)
      ) {
        this._toastMessage.openSnackBarError(
          'First name is a mandatory field and please enter letters(A-Z).'
        )
      } else {
        this._basicInfoService
          .updateFirstName(this.basicData.firstName, this.basicData.userId._id)
          .subscribe(
            (res) => {
              response = res
              this.firstNameInput.emit(this.basicData.firstName)
              this.userInitialData.firstName = this.basicData.firstName
              this._toastMessage.openSnackBarSuccess(
                'Updated first name successfully'
              )
            },
            (error) => {
              const errorMessage = error.error.message
              this._toastMessage.openSnackBarError(
                errorMessage || 'Could not update first name'
              )
            }
          )
      }
    }
  }

  updateLastName() {
    let response
    if (this.userInitialData.lastName === this.basicData.lastName) {
      this._toastMessage.openSnackBarError('Please change the value to update')
    } else {
      if (
        (this.lastNameFormControl.errors &&
          this.lastNameFormControl.errors.pattern) ||
        (this.lastNameFormControl.errors &&
          this.lastNameFormControl.errors.required) ||
        !this.basicData.lastName.trim()
      ) {
        this._toastMessage.openSnackBarError(
          'Last name is a mandatory field and please enter letters(A-Z)'
        )
      } else {
        if ((this.lastNameFormControl.errors && this.lastNameFormControl.errors.pattern) ||
          (this.lastNameFormControl.errors && this.lastNameFormControl.errors.required) || !this.basicData.lastName.trim()) {
          this._toastMessage.openSnackBarError('Last name is a mandatory field and please enter letters(A-Z)');
        } else {
          this._basicInfoService.updateLastName(this.basicData.lastName, this.basicData.userId._id).subscribe(res => {
            response = res;
            this.userInitialData.lastName = this.basicData.lastName;
            this._toastMessage.openSnackBarSuccess('Updated last name successfully');
          },
            error => {
              const errorMessage = error && error.error && error.error.message || 'Could not last name';
              this._toastMessage.openSnackBarError(errorMessage);
            });
        }
      }
    }
  }

  updateMobile() {
    let response
    if (
      (this.mobileFormControl.errors &&
        this.mobileFormControl.errors.pattern) ||
      (this.mobileFormControl.errors && this.mobileFormControl.errors.required)
    ) {
      this._toastMessage.openSnackBarError(
        'Mobile number is a mandatory field.' +
        'It should only contain numbers and should be 10 digits long'
      )
    } else {
      this._basicInfoService
        .updateMobile(this.basicData.mobile, this.basicData.userId._id)
        .subscribe(
          (res) => {
            response = res
            this.userInitialData.mobile = this.basicData.mobile
            this._toastMessage.openSnackBarSuccess(
              'Updated mobile number successfully'
            )
          },
          (error) => {
            const errorMessage =
              (error && error.error && error.error.message) ||
              'Could not mobile'
            this._toastMessage.openSnackBarError(errorMessage)
          }
        )
    }
  }

  logoutCaptain() {
    let response
    this.spinnerService.show()
    this._basicInfoService.logoutCaptain(this.basicData.userId._id).subscribe(
      (res) => {
        this.spinnerService.hide()
        response = res
        this._toastMessage.openSnackBarSuccess('Captain logged out')
      },
      (error) => {
        this.spinnerService.hide()
        const errorMessage =
          error.error && error.error.message
            ? error.error.message
            : 'Could not logout captain'
        this._toastMessage.openSnackBarError(errorMessage)
      }
    )
  }

  genderToggle(evt: any) {
    let response
    const prevGender = this.gender[this.resolveCaptainGender(this.userInitialData)]
    let changedGender
    let genderValue: number
    if (evt.value === 'Female') {
      genderValue = 1
      changedGender = 'female'
    } else if (evt.value === 'Male') {
      genderValue = 0
      changedGender = 'male'
    } else if (evt.value === 'Other') {
      genderValue = 2
      changedGender = 'other'
    } else {
      return
    }
    this.setCaptainGender(this.basicData, genderValue)
    const riderId = this.basicData._id || (this.basicData.userId && this.basicData.userId._id)
    this.spinnerService.show()
    this._basicInfoService
      .updateGender(genderValue, riderId)
      .subscribe(
        (res) => {
          this.spinnerService.hide()
          response = res
          this.setCaptainGender(this.userInitialData, genderValue)
          this._toastMessage.openSnackBarSuccess('Updated gender successfully')
        },
        (error) => {
          this.spinnerService.hide()
          const errorMessage =
            error.error && error.error.message
              ? error.error.message
              : 'Could not update gender'
          this._toastMessage.openSnackBarError(errorMessage)
        }
      )
  }

  /**
   * Check if a type option should be disabled when rider is active
   * @param typeOption - The type option to check ('e-rickshaw', 'no-dl', etc.)
   * @returns boolean - true if the type option should be disabled
   */
  isTypeDisabledWhenActive(typeOption: string): boolean {
    // If rider is not active, don't disable any options
    if (!this.basicData.active) {
      return false;
    }

    // If the type option is 'e-rickshaw' and rider is active, always disable it
    if (typeOption === 'e-rickshaw') {
      return true;
    }

    // For all other cases, don't disable
    return false;
  }

  onTypeChange(evt: any) {
    const selectedType = evt.value;
    const prevType = this.basicData.type;

    // Map e-rickshaw to Erickshaw for backend
    const backendType = selectedType === 'e-rickshaw' ? 'Erickshaw' : selectedType;

    this.spinnerService.show();
    this._basicInfoService
      .updateRiderType(backendType, this.basicData._id, this.actorId)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          this.basicData.type = selectedType;
          this.noDlOrRcRider = "E-Rickshaw";
          this._toastMessage.openSnackBarSuccess('Updated type to E-Rickshaw successfully');
        },
        (error) => {
          this.spinnerService.hide();
          this.basicData.type = prevType;
          const errorMessage =
            error.error && error.error.message
              ? error.error.message
              : 'Could not update type';
          this._toastMessage.openSnackBarError(errorMessage);
        }
      );
  }

  onTypeRadioChange(evt: any) {
    const selectedType = evt.value;
    const prevType = this.basicData.type;

    // Map e-rickshaw to Erickshaw for backend
    const backendType = selectedType === 'e-rickshaw' ? 'Erickshaw' : selectedType;

    this.spinnerService.show();
    this._basicInfoService
      .updateRiderType(backendType, this.basicData._id, this.actorId)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          this.basicData.type = selectedType;
          this.noDlOrRcRider = "E-Rickshaw";
          this._toastMessage.openSnackBarSuccess(`Updated type to ${this.getTypeDisplayName(selectedType)} successfully`);

          // Emit type change to parent component (emit the backend type for consistency)
          this.typeChange.emit(backendType);
        },
        (error) => {
          this.spinnerService.hide();
          this.basicData.type = prevType;
          const errorMessage =
            error.error && error.error.message
              ? error.error.message
              : 'Could not update type';
          this._toastMessage.openSnackBarError(errorMessage);
        }
      );
  }

  onRadioButtonClick(event: any, typeOption: string) {
    // Prevent the default radio button behavior temporarily
    event.preventDefault();
    event.stopPropagation();

    // Check if this option is disabled when rider is active
    if (this.isTypeDisabledWhenActive(typeOption)) {
      // Don't allow any action if disabled
      return;
    }

    // If clicking on already selected radio button, deselect it
    if (this.basicData.type === typeOption) {
      this.deselectType();
    } else {
      // Block converting to B2B (noDl) when the captain has suspended services.
      if (typeOption === 'noDl' && this.suspendedServiceGroups && this.suspendedServiceGroups.length) {
        this._toastMessage.openSnackBarError(this.getSuspendedBlockMessage());
        return;
      }
      // If clicking on different radio button, select it
      this.basicData.type = typeOption;
      // Trigger the change event manually
      this.onTypeRadioChange({ value: typeOption });
    }
  }

  private getSuspendedServiceNames(): string[] {
    return (this.suspendedServiceGroups || [])
      .map(group => group && (group.displayName || group.subServiceType
        || (group.services && group.services.join(', '))))
      .filter(Boolean);
  }

  private getSuspendedBlockMessage(): string {
    const names = this.getSuspendedServiceNames();
    if (names.length > 1) {
      return `Type cannot be changed to B2B because ${names.join(', ')} services are suspended`;
    }
    if (names.length === 1) {
      return `Type cannot be changed to B2B because ${names[0]} service is suspended`;
    }
    return 'Type cannot be changed to B2B because a service is suspended';
  }

  deselectType() {
    const prevType = this.basicData.type;

    this.spinnerService.show();
    this._basicInfoService
      .updateRiderType('rapido', this.basicData._id, this.actorId)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          this.basicData.type = null; // Set to null to deselect radio button
          this.noDlOrRcRider = "";
          this._toastMessage.openSnackBarSuccess('Type updated to rapido successfully');

          // Emit type change to parent component (emit 'rapido' since that's what we updated to)
          this.typeChange.emit('rapido');
        },
        (error) => {
          this.spinnerService.hide();
          this.basicData.type = prevType; // Revert on error
          const errorMessage =
            error.error && error.error.message
              ? error.error.message
              : 'Could not update type to rapido';
          this._toastMessage.openSnackBarError(errorMessage);
        }
      );
  }

  normalizeTypeValue() {
    // Normalize the type value to match what's available in typeOptions
    if (this.basicData && this.basicData.type && this.typeOptions && this.typeOptions.length > 0) {
      // If current type is "Erickshaw" but typeOptions contains "e-rickshaw", normalize it
      if (this.basicData.type === 'Erickshaw' && this.typeOptions.includes('e-rickshaw') && !this.typeOptions.includes('Erickshaw')) {
        this.basicData.type = 'e-rickshaw';
      }
      // If current type is "e-rickshaw" but typeOptions contains "Erickshaw", normalize it
      else if (this.basicData.type === 'e-rickshaw' && this.typeOptions.includes('Erickshaw') && !this.typeOptions.includes('e-rickshaw')) {
        this.basicData.type = 'Erickshaw';
      }
    }
  }

  confirmationForModeChange(selectedMode: any) {
    const confirmationRequired =
      (this.data && this.data.toggles && this.data.toggles.modeChangeEnabled) ||
      false
    if (!confirmationRequired) {
      this.modeToggle(selectedMode)
      return
    }

    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '550px',
      data: {
        options: [],
        title: 'Are you sure you want to change the mode for captain?',
        notes: [
          'This would remove the existing services of the captain.',
          'Account will be deactivated.',
          'Necessary documents need to be re-verified',
        ],
        reason: 'modeChange',
        buttonText: 'Change',
        styles: {
          title: 'deactivate-title',
          actionClass: 'deactivate-merchant-popup',
        },
      },
    })

    dialogRef.afterClosed().subscribe((modeChange) => {
      if (modeChange) {
        this.modeToggle(selectedMode)
      } else {
        this.modeName = this.basicData.modeId.mode
      }
    })
  }



  modeToggle(selectedMode: any) {
    const mode = selectedMode.value
    this.spinnerService.show()
    const modeInfo =
      this.modes.filter((item) => item && item.mode === mode)[0] || {}
    this.spinnerService.hide()
    this.selectedMode = modeInfo
    const modeId = modeInfo._id
    const userId =
      this.basicData._id
    const cityId =
      this.basicData && this.basicData.city && this.basicData.city._id
    this._basicInfoService.updateMode(modeId, userId, cityId, this.userInitialData.mode, modeInfo.mode).subscribe(
      (response: any) => {
        this.basicData.modeId = { _id: modeId, mode: modeInfo.mode }
        const previousMode = this.userInitialData.modeId || {}
        this.userInitialData.modeId = this.basicData.modeId
        this.modeName = modeInfo.mode
        this.modeChange.emit({ _id: modeId, mode: modeInfo.mode })
        this._toastMessage.openSnackBarSuccess('Updated mode successfully')
        if (previousMode.mode === 'Auto' &&
          (modeInfo.mode === 'Bike' || modeInfo.mode === 'Car') &&
          (this.basicData.type === 'Erickshaw' || this.basicData.type === 'e-rickshaw')) {
          // Automatically change type from Erickshaw to rapido
          this._basicInfoService
            .updateRiderType('rapido', this.basicData._id, this.actorId)
            .subscribe(
              (typeResponse) => {
                this.basicData.type = 'rapido';
                this.noDlOrRcRider = "";
                this._toastMessage.openSnackBarSuccess('Type automatically changed from Erickshaw to rapido due to mode change');

                // Emit type change to parent component
                this.typeChange.emit('rapido');
              },
              (typeError) => {
                const errorMessage = typeError.error && typeError.error.message
                  ? typeError.error.message
                  : 'Failed to automatically update type to rapido';
                this._toastMessage.openSnackBarError(`Mode updated successfully, but ${errorMessage}`);
              }
            );
        }

        // Fetch type config for the new mode
        this.logTypeConfigInfo('Mode changed successfully, fetching type config for new mode', {
          newMode: modeInfo.mode,
          previousMode: this.userInitialData.mode
        });
        this.fetchTypeConfig()
      },
      (error) => {
        this.spinnerService.hide()
        this._toastMessage.openSnackBarError('Failed to update mode')
      }
    )
  }

  checkForCaptainMode(mode) {
    const modeInfo =
      this.modes.filter((item) => item && item.mode === mode)[0] || {}
    if (this.basicData.modeId && this.basicData.modeId._id === modeInfo._id) {
      return true
    }
    return false
  }

  fetchAgentLastDisposition(mobile) {
    if (this.isActive) {
      this.showLastDisposition = false;
      return;
    }
    this._basicInfoService.getLastDisposition(mobile).subscribe((res: any) => {
      if (res && res.data && res.data.data && res.data.data.agentLastDisposition) {
        this.lastDisposition = res.data.data.agentLastDisposition
        this.showLastDisposition = true;
        this.lastDispositionFormControl.disable();
        return res.data
      } else {
        this.showLastDisposition = false;
      }
    }, error => {
      this.showLastDisposition = false;
      const errorMessage = error.error && error.error.message ? error.error.message : 'Could not fetch last disposition';
      this._toastMessage.openSnackBarError(errorMessage);
    });
  }

  fetchCaptainInstalledApps(mobile) {
    // if (this.isActive) {
    //   this.showCaptainInstalledApps = false;
    //   return;
    // }

    this._basicInfoService.getCaptainInstalledApps(mobile).subscribe((res: any) => {
      if (res && res.data && res.data.data && res.data.data.captainInstalledApps && res.data.data.captainInstalledApps.length > 0) {
        this.captainInstalledApps = res.data.data.captainInstalledApps
        this.showCaptainInstalledApps = true;
        this.captainInstalledAppsFormControl.disable();
        return res.data
      } else {
        this.showCaptainInstalledApps = false;
      }
    }, error => {
      this.showCaptainInstalledApps = false;
      const errorMessage = error.error && error.error.message ? error.error.message : 'Could not fetch captain installed apps';
      this._toastMessage.openSnackBarError(errorMessage);
    });
  }

  fetchRiderLogs() {
    const userId = this.basicData._id
    this.router.navigate([`/riderLogs/${userId}`])
  }

  calculateFinalAmount(baseAmount, discount) {
    return baseAmount - (baseAmount * discount) / 100
  }

  updateBirthDate() {
    const submittedBirthDate = _.cloneDeep(this.basicData.birthDate)
    this._basicInfoService
      .updateBirthDate(submittedBirthDate, this.basicData._id)
      .subscribe(
        (res: any) => {
          if (!res || res.dobSaved !== true) {
            this._toastMessage.openSnackBarError(this.birthDateNotSavedMessage(res))
            this.basicData.birthDate = _.cloneDeep(this.userInitialData.birthDate)
            this.birthDateFormControl.reset(this.basicData.birthDate)
            return
          }
          this.userInitialData.birthDate = submittedBirthDate
          this._toastMessage.openSnackBarSuccess(
            'Updated date of birth successfully'
          )
          this.birthDate.emit(submittedBirthDate)
        },
        (error) => {
          const errorMessage =
            error.error && error.error.message
              ? error.error.message
              : 'Could not update birth date'
          this._toastMessage.openSnackBarError(errorMessage)
        }
      )
  }

  birthDateNotSavedMessage(res: any): string {
    const data = res && res.data
    if (data && data.dobOutcome === 'dob_update_skipped') {
      if (data.dobPreviousSource === 'aadhar') {
        return 'DOB not updated: Aadhaar DOB has priority'
      }
      if (data.dobPreviousSource) {
        return `DOB not updated: ${data.dobPreviousSource} DOB has priority`
      }
      return 'DOB not updated: existing DOB has priority'
    }
    return 'Could not update birth date'
  }

  datePickerOpened(evt: any) {
    this._hotkeysService.add(
      new Hotkey('left', (event: KeyboardEvent): boolean => {
        event.preventDefault()
        return false // Prevent bubbling
      })
    )
    this._hotkeysService.add(
      new Hotkey('right', (event: KeyboardEvent): boolean => {
        event.preventDefault()
        return false // Prevent bubbling
      })
    )
  }

  datePickerClosed(evt: any) {
    this._hotkeysService.add(
      new Hotkey('left', (event: KeyboardEvent): boolean => {
        document.getElementById('backButton').click()
        return false // Prevent bubbling
      })
    )
    this._hotkeysService.add(
      new Hotkey('right', (event: KeyboardEvent): boolean => {
        document.getElementById('nextButton').click()
        return false // Prevent bubbling
      })
    )
  }
  getB2bEligibility(riderId) {
    return new Promise<void>((resolve, reject) => {
      this._basicInfoService.getB2bEligibility(riderId).subscribe(
        (result) => {
          this.b2bEligibileFlagToggle =
            result && result['B2B_ELIGIBLE_TOGGLE'] == 'false' ? false : true
          this.isB2BEligible =
            result && result.hasOwnProperty('isEligible')
              ? result['isEligible']
                ? 'YES'
                : 'NO'
              : ''
          this.notEligibleReasons = (result && result['message']) || []
          resolve()
        },
        (error) => {
          const errorMessage =
            (error && error.error && error.error.message) ||
            'Could not fetch B2B eligiblity status'
          this.b2bEligibleApiErrorMessage = errorMessage
          this._toastMessage.openSnackBarError(errorMessage)
          reject()
        }
      )
    })
  }
  resetB2bEligibilityVariables() {
    this.isB2BEligible = ''
    this.b2bEligibileFlagToggle = true
  }




  showB2bEligibility() {
    this.resetB2bEligibilityVariables()
    var userId = this.basicData._id
    this.isRefreshing = true
    this.isEligibilityApiCalled = true
    this.getB2bEligibility(userId)
      .then(() => {
        this.isRefreshing = false
      })
      .catch(() => {
        this.isRefreshing = false
      })
  }

  viewPhoneNumberChangeRequest(evt) {
    this.showChangeRequest = evt.checked
    if (this.showChangeRequest) {
      this._basicInfoService
        .getPhoneNumberChangeRequest(this.basicData._id)
        .subscribe(
          (response) => {
            this.mobileChangeRequest = response['data']
            this.numberChangeRejectionReasons = this.mobileChangeRequest['numberChangeRejectionReasons']
            this._basicInfoService.sendAgentEvent(this.mobileChangeRequest.uuid, this.mobileChangeRequest.riderId, "change_phone_number_toggle_click").subscribe(res => {
              console.log("agent event sent successfully")
            })
            this.basicData.modes.forEach((mode) => {
              if (mode._id === this.mobileChangeRequest.meta.newModeId) {
                this.newMode = mode.mode
                return;
              }
            })
          },
          (error) => {
            const errorMessage =
              (error && error.error && error.error.message) ||
              'Failed to fetch mobile change request'
            this._toastMessage.openSnackBarError(errorMessage)
            this.showChangeRequest = false
          }
        )
    }
  }

  approvePNR() {
    this._basicInfoService.approvePNR(this.basicData._id).subscribe(
      (resposne) => {
        this.showChangeRequest = false
        this.approvedChangeRequest = true
      },
      (error) => {
        const errorMessage =
          (error && error.error && error.error.message) ||
          'Failed to approve mobile change request'
        this._toastMessage.openSnackBarError(errorMessage)
      }
    )
  }

  rejectPNR() {
    const dialogRef = this.dialog.open(RemarkPopUpComponent, {
      data: {
        numberChangeRejectionReasons: this.numberChangeRejectionReasons
      }
    })
    const riderId = this.basicData._id
    dialogRef.afterClosed().subscribe(
      (remarks) => {
        this._basicInfoService.rejectPNR(riderId, remarks).subscribe(
          (response) => {
            this.showChangeRequest = false
            this.rejectedChangeRequest = true
          },
          (error) => {
            const errorMessage =
              (error && error.error && error.error.message) ||
              'Failed to reject mobile change request'
            this._toastMessage.openSnackBarError(errorMessage)
          }
        )
      },
      (error1) => {
        console.log(error1)
      }
    )
  }


  sendR2AWhatsappMessage() {
    this.spinnerService.show();
    this.whatsappAckowledgementPositiveFeedback = ''
    this.whatsappAckowledgementNegativeFeedback = ''
    this.isAllowedToSendR2AWhatsappMessage = false
    console.log(this.basicData)
    this._basicInfoService.sendR2AWhatsappMessage(this.basicData._id).subscribe(res => {
      this.spinnerService.hide();
      this.whatsappAckowledgementPositiveFeedback = 'Message sent';
    },
      error => {
        this.spinnerService.hide();
        const errorMessage = error.error && error.error.message ? error.error.message : 'Failed to send whatsapp message';
        this.whatsappAckowledgementNegativeFeedback = errorMessage;
      });
  }

  getUserPreferencesInformation(riderId, city) {
    const modeName = this.getModeName();
    this._basicInfoService.getUserPreference(riderId, city, modeName).subscribe(result => {
      this.userPreferences.emit(result);
      const preferences = result && result['data'] && result['data'].serviceTypePreferences;
      this.suspendedServiceGroups = (preferences && preferences.suspendedServices) || [];
      //2969 | disabling Assure information on supply dashboard 
      // this.getAssureInformation(result);

    }, error => {
      const errorMessage = error && error.error && error.error.message || 'Could not assure payment details';
      this._toastMessage.openSnackBarError(errorMessage);
    });

  }
  getAssureInformation(result) {
    let response = this.filterAssureDetails(result);
    const joiningFeeInfo = response && response['joiningFeeInfo'] || {};
    if (joiningFeeInfo) {
      const len = joiningFeeInfo && joiningFeeInfo['transactionProgress'] && joiningFeeInfo['transactionProgress'].length || 0;
      const paymentStatus = len > 0 ? joiningFeeInfo['transactionProgress'][len - 1].status : " ";
      this.isAssureServiceEnabled = paymentStatus == "completed" ? true : false;
      this.assureFees = this.calculateFinalAmount(parseInt(joiningFeeInfo['baseAmount']), parseInt(joiningFeeInfo['discountPercentage']));
    }
  }

  filterAssureDetails(result) {
    return result && result.data && result.data.serviceOnboardingConfig && result.data.serviceOnboardingConfig &&
      result.data.serviceOnboardingConfig.serviceTypeProgress && result.data.serviceOnboardingConfig.serviceTypeProgress.delivery &&
      result.data.serviceOnboardingConfig.serviceTypeProgress.delivery.food || {};

  }

  fetchTypeConfig() {
    // Get config from service
    if (!this.basicData || !this.data) {
      this.logTypeConfigInfo('Type config fetch skipped: basicData or data is missing', {
        basicData: !!this.basicData,
        data: !!this.data
      });
      return;
    }

    const cityId = (this.data.city && this.data.city._id) ? this.data.city._id : this.data.city;
    const modeName = (this.basicData.modeId && this.basicData.modeId.mode) ? this.basicData.modeId.mode :
      (this.basicData.mode ? this.basicData.mode :
        (this.modeName ? this.modeName : ''));

    this.logTypeConfigInfo('Fetching type config', { cityId, modeName });

    if (!cityId || !modeName) {
      this.logTypeConfigInfo('Type config fetch skipped: cityId or modeName is missing', { cityId, modeName });
      return;
    }

    this._basicInfoService.getTypeConfig(cityId, modeName).then(
      (response: any) => {
        this.logTypeConfigInfo('Type config API response received', {
          hasResponse: !!response,
          success: response && response.success,
          hasData: response && response.data
        });

        if (response && response.success && response.data) {
          const config = response.data;
          this.isTypeVisible = config.isTypeVisible === true;
          this.optionalDocs = Array.isArray(config.optionalDocs) ? config.optionalDocs : [];
          this.typeOptions = Array.isArray(config.type) ? config.type : [];
          this.typeServiceMap = config.typeServiceMap && typeof config.typeServiceMap === 'object' ? config.typeServiceMap : {};

          this.logTypeConfigInfo('Type config applied successfully', {
            isTypeVisible: this.isTypeVisible,
            optionalDocs: this.optionalDocs.length,
            typeOptionsCount: this.typeOptions.length,
            typeServiceMapKeys: Object.keys(this.typeServiceMap).length,
            types: this.typeOptions
          });

          // Log successful config fetch
          this.logTypeConfigSuccess(config);

          // Emit typeServiceMap to parent component
          this.typeServiceMapping.emit(this.typeServiceMap);

          // Normalize type value after config is loaded
          this.normalizeTypeValue();
        } else {
          // Reset to default values if response is invalid
          this.isTypeVisible = false;
          this.optionalDocs = [];
          this.typeOptions = [];
          this.typeServiceMap = {};

          this.logTypeConfigInfo('Type config reset due to invalid response', {
            responseStructure: {
              hasResponse: !!response,
              hasSuccess: response && response.hasOwnProperty('success'),
              hasData: response && response.hasOwnProperty('data')
            }
          });

          // Log invalid response
          this.logTypeConfigError('Invalid response structure', { message: 'Response missing success or data properties', response: response });

          // Emit empty typeServiceMap to parent component
          this.typeServiceMapping.emit(this.typeServiceMap);
        }
      },
      (error) => {
        this.logTypeConfigError('Error fetching type config', error);
        // Reset to default values on error
        this.isTypeVisible = false;
        this.optionalDocs = [];
        this.typeOptions = [];
        this.typeServiceMap = {};

        // Emit empty typeServiceMap to parent component
        this.typeServiceMapping.emit(this.typeServiceMap);
      }
    );
  }

  getTypeDisplayName(typeValue: string): string {
    const typeDisplayMap = {
      'Erickshaw': 'E-Rickshaw',
      'e-rickshaw': 'E-Rickshaw',
      'noDl': 'B2B',
      'noRc': 'Rental Bike/Auto'
    };
    return typeDisplayMap[typeValue] || typeValue;
  }

  updateDisplayTextForType(selectedType: string) {
    if (selectedType === "noDl") {
      this.noDlOrRcRider = "B2B";
    } else if (selectedType === "Erickshaw" || selectedType === "e-rickshaw") {
      this.noDlOrRcRider = "E-Rickshaw";
    } else if (selectedType === "noRc") {
      this.noDlOrRcRider = "Rental Bike/Auto";
    } else {
      this.noDlOrRcRider = this.getTypeDisplayName(selectedType);
    }
  }

  getServiceIdsForType(typeValue: string): string[] {
    return this.typeServiceMap[typeValue] || [];
  }

  // Logging methods for type config operations
  private logTypeConfigError(message: string, error: any) {
    const userId = this.basicData && this.basicData._id ? this.basicData._id : 'unknown';
    const metadata = {
      message: message,
      error: error.message || error,
      errorStatus: error.status,
      userId: userId,
      cityId: this.data && this.data.city ? (this.data.city._id || this.data.city) : 'unknown',
      modeName: this.getModeName(),
      timestamp: new Date().toISOString()
    };

    this._logService.insertEventWithType('type-config-error', userId, {}, {}, metadata);
  }

  private logTypeConfigSuccess(configData: any) {
    const userId = this.basicData && this.basicData._id ? this.basicData._id : 'unknown';
    const metadata = {
      message: 'Type config fetched successfully',
      isTypeVisible: configData.isTypeVisible,
      optionalDocs: configData.optionalDocs ? configData.optionalDocs.length : 0,
      typeCount: configData.type ? configData.type.length : 0,
      hasServiceMap: !!configData.typeServiceMap,
      userId: userId,
      cityId: this.data && this.data.city ? (this.data.city._id || this.data.city) : 'unknown',
      modeName: this.getModeName(),
      timestamp: new Date().toISOString()
    };

    this._logService.insertEventWithType('type-config-success', userId, {}, configData, metadata);
  }

  private getModeName(): string {
    if (this.basicData && this.basicData.modeId && this.basicData.modeId.mode) {
      return this.basicData.modeId.mode;
    }
    if (this.basicData && this.basicData.mode) {
      return this.basicData.mode;
    }
    if (this.modeName) {
      return this.modeName;
    }
    return 'unknown';
  }

  private logTypeConfigInfo(message: string, data: any) {
    const userId = this.basicData && this.basicData._id ? this.basicData._id : 'unknown';
    const metadata = {
      message: message,
      timestamp: new Date().toISOString()
    };

    this._logService.insertEventWithType('type-config-info', userId, {}, data, metadata);
  }

}
